import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  OnInit,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PromoStayInTouchForm } from 'www-cms';
import { DirectusDirective } from 'directus';
import { BaseBuildingBlockComponent } from '../components/base-building-block.component';
import { LastItemBgClass } from '../../shell/shell.service';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ButtonComponent } from 'ui-elements/button';
import { FormFieldModule } from 'ui-elements/form-field';
import { BaseInputDirective } from 'ui-elements/form/input/base-input.directive';
import { ForbiddenDomainsValidatorDirective, regularExpressions } from 'common';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { CountryService } from 'api';
import { CommonModule as SSCommonModule } from 'common';
import { SelectData, ssSelectImports } from 'ui-elements/select';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
  selector: 'ss-www-promo-stay-in-touch-form',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormFieldModule,
    ButtonComponent,
    ssSelectImports,
    SSCommonModule,
    BaseInputDirective,
    ForbiddenDomainsValidatorDirective,
    NgxMaskDirective,
    DirectusDirective,
  ],
  templateUrl: './promo-stay-in-touch-form.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PromoStayInTouchFormComponent
  extends BaseBuildingBlockComponent
  implements OnDestroy, OnInit
{
  private countryService = inject(CountryService);

  @Input({ required: true }) promoStayInTouchFormData!: PromoStayInTouchForm;

  override getBgClass(): LastItemBgClass {
    return 'bg-ss-www-background';
  }

  countries$ = new BehaviorSubject<SelectData[] | null>(null);

  form = new FormGroup({
    organization: new FormControl(''),
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    primaryPhone: new FormControl('', [
      Validators.required,
      Validators.pattern(regularExpressions.onlyNumbersPattern),
      Validators.maxLength(20),
      Validators.minLength(10),
    ]),
    emailAddress: new FormControl('', [Validators.required]),
    country: new FormControl('USA', [Validators.required]),
    address: new FormControl('', [Validators.required]),
    city: new FormControl('', [Validators.required]),
    state: new FormControl('', [Validators.required, Validators.maxLength(2)]),
    zipCode: new FormControl('', [Validators.required]),
  });

  onDestroy$ = new Subject<void>();

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
  ngOnInit(): void {
    this.countryService
      .getCountries()
      ?.pipe(takeUntil(this.onDestroy$))
      .subscribe((countries) => {
        this.countries$.next(
          countries.map((key) => ({
            value: key.code,
            name: key.name,
          }))
        );
      });
    this.form.controls.country.valueChanges
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((value) => {
        if (value === 'USA') {
          if (
            this.form.controls.state.value &&
            this.form.controls.state.value.length > 2
          ) {
            this.form.patchValue({ state: '' });
          }
          this.form.controls.state.setValidators([
            Validators.required,
            Validators.maxLength(2),
          ]);
        } else {
          this.form.controls.state.setValidators([Validators.required]);
        }
      });
  }

  onSubmit() {
    console.log(this.form.invalid);
    console.log(this.form.getRawValue());
  }
}
